import * as React from "react";
import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SvgZoomIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 21 20">
      <path d="M9.83333 14.6667C12.7789 14.6667 15.1667 12.2789 15.1667 9.33333C15.1667 6.38781 12.7789 4 9.83333 4C6.88781 4 4.5 6.38781 4.5 9.33333C4.5 12.2789 6.88781 14.6667 9.83333 14.6667Z" 
        stroke="#C72037" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <path d="M16.4996 16.0001L13.5996 13.1001" stroke="#BE1A2E" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.83301 7.3335V11.3335" stroke="#BE1A2E" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M7.83301 9.3335H11.833" stroke="#BE1A2E" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
    </SvgIcon>
  );
};

export default SvgZoomIcon;
